import { all, call, spawn } from 'redux-saga/effects';
import {
  authSagaWatcher,
  getAllLocationsWatcher,
  getAllKidsWatcher,
  getAllPlansWatcher,
  createKidWatcher,
  getAllAddressWatcher,
  saveRecurringPlanWatcher,
  resetCreateKidSuccessWatcher
} from '../saga/authSaga';

// Root saga
function* rootSaga() {
  const sagas = [authSagaWatcher, getAllLocationsWatcher, getAllKidsWatcher, getAllPlansWatcher, createKidWatcher, getAllAddressWatcher, saveRecurringPlanWatcher, resetCreateKidSuccessWatcher];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log('Error ', e);
          }
        }
      }),
    ),
  );
}

export default rootSaga;
